// 550 - 767
import store from 'store';
import { mediaQueryActions } from 'store/features';

const media = {
  xs: '(max-width: 320px)',
  sm: '(max-width: 576px)',
  md: '(max-width: 768px)',
  lg: '(max-width: 992px)',
  xlg: '(max-width: 1400px)'
};

init();
function init() {
  window.addEventListener('resize', mediaQuery);
  window.addEventListener('load', mediaQuery);
  window.addEventListener('DOMNodeInserted', mediaQuery);
}

export default function mediaQuery() {
  const xs = window.matchMedia(media.xs).matches;
  const sm = window.matchMedia(media.sm).matches;
  const md = window.matchMedia(media.md).matches;
  const lg = window.matchMedia(media.lg).matches;
  const xlg = window.matchMedia(media.xlg).matches;

  const breakPoints = { xs, sm, md, lg, xlg };
  store.dispatch(mediaQueryActions.setMediaQuery(breakPoints));

  const innerHeight = `${window.innerHeight}px`;
  store.dispatch(mediaQueryActions.setInnerHeight(innerHeight));

  return breakPoints;
}
